/**
 * Size presets for `IconButton`. Controls the padding/touch-target size around
 * the icon:
 * - `NONE` — no extra size modifier; uses the default compact sizing.
 * - `L` — large touch target, suitable for primary actions.
 * - `XL` — extra-large touch target, suitable for prominent toolbar controls.
 */
export enum SIZES {
    NONE = 'SIZE.NONE',
    L = 'SIZE.L',
    XL = 'SIZE.XL',
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const sizeValues = [...Object.values(SIZES)] as const;

/** Union of all valid `SIZES` values (`"SIZE.NONE"` | `"SIZE.L"` | `"SIZE.XL"`). */
export type SizeType = typeof sizeValues[number];

export const SIZES_CLASSES: {[key in SIZES]: string | null} = {
    [SIZES.NONE]: null,
    [SIZES.L]: 'icon-button_size-l',
    [SIZES.XL]: 'icon-button_size-xl',
};
